import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { connect } from "pwa-helpers";
import store from "../../../store/store";
import { BaseComponent } from "../../base-component/base-component";
import './security-field';
import './password-field';

@customElement('mhecomm-security-tab')
export class SecurityTab extends connect(store)(BaseComponent) {
  renderComp() {
    return html`
      <div class="row g-2">
        <div class="col-12">
          <mhecomm-password-field></mhecomm-password-field>
        </div>
        <div class="col-12">
          <hr />
        </div>
        <div class="col-12">
          <mhecomm-security-field></mhecomm-security-field>
        </div>
        <div class="col-12">
          <mhecomm-password-validation></mhecomm-password-validation>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-security-tab': SecurityTab;
  }
}
